const config = {
  authCookieName: 'AUTH_JWT',
  api: {
    baseUrl:
      process.env.REACT_APP_ENV === 'production'
        ? 'https://api.thefruitsupplier.com'
        : 'https://api-dev.thefruitsupplier.com',
    timeout: 30000,
    defaultQuery: {
      limit: 50,
      sortBy: 'createdTime',
      sortDirection: 'desc'
    }
  },
  product: {
    limit: 100
  },
  cookies: {
    defaultExpireTime: 60 * 60 * 24 * 1000
  },
  aws: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
    cognito: {
      userPoolId:
        process.env.REACT_APP_ENV === 'production'
          ? 'us-east-1_nA8kbiPQd'
          : 'us-east-1_nA8kbiPQd',
      authorizedUsersGroupName: 'fruit-supplier-cp-admin'
    }
  },
  delayMS: {
    forceLogout: 3000
  }
}

export default config
